import React from 'react';
import HostingerStyleServiceTemplate from '../../components/HostingerStyleServiceTemplate';
import FounderInsight from '../../components/FounderInsight';
import { FaBuilding, FaChartLine, FaGlobe, FaLaptopCode, FaShoppingCart, FaMobileAlt, FaUsers, FaEuroSign, FaSearch, FaRocket, FaShieldAlt, FaComments, FaCode } from 'react-icons/fa';
import Button from '../../components/Button';

const WebEmpresasPage = () => {
  // Keyword principal: "página web barata"
  const mainKeyword = "página web barata";
  
  // Enlaces internos relacionados
  const relatedLinks = [
    { url: "/servicios/diseno-web-pymes", text: "Página web barata para PYMES" },
    { url: "/servicios/diseno-web-autonomos", text: "Página web barata para autónomos" },
    { url: "/servicios/diseno-web-abogados", text: "Página web barata para abogados" },
    { url: "/servicios/diseno-web-psicologos", text: "Página web barata para psicólogos" },
    { url: "/precios", text: "Ver todos nuestros precios" },
    { url: "/proceso", text: "Conoce nuestro proceso de trabajo" }
  ];
  
  // Lista de beneficios adaptados al buyer persona José
  const benefits = [
    {
      title: "Genera ventas mientras te dedicas a lo importante",
      description: "Tu web trabaja 24/7 capturando clientes. Mientras gestionas tu empresa, el sitio web consigue contactos que se convierten en ventas reales."
    },
    {
      title: "Compite con grandes empresas sin su presupuesto",
      description: "Una web profesional te pone al mismo nivel que competidores más grandes. Los clientes juzgan por lo que ven online antes de decidir dónde comprar."
    },
    {
      title: "Multiplica tu credibilidad instantáneamente",
      description: "El 81% de clientes investiga online antes de comprar. Una web profesional transmite confianza y seriedad, eliminando dudas sobre tu empresa."
    },
    {
      title: "Reduce costes de publicidad tradicional",
      description: "Una campaña en periódicos locales cuesta entre 500€-2000€ y dura días. Tu web funciona años por un coste similar, generando resultados constantemente."
    },
    {
      title: "Amplía tu alcance geográfico",
      description: "Atrae clientes de otras zonas que nunca conocerían tu empresa por otros medios. Expande tu negocio más allá de tu ubicación física."
    },
    {
      title: "Recupera la inversión con pocos clientes",
      description: "Con solo 1-2 ventas medianas recuperas el coste total de la web. La mayoría de clientes recuperan la inversión en el primer mes."
    }
  ];
  
  // Características adaptadas al buyer persona José
  const features = [
    {
      icon: <FaBuilding />,
      title: "Diseño corporativo que impresiona",
      description: "Creamos una web que refleja la profesionalidad de tu empresa. Diseño adaptado a tu sector que muestra lo mejor de tu negocio."
    },
    {
      icon: <FaShoppingCart />,
      title: "Catálogo de productos que vende",
      description: "Presentamos tus productos o servicios de forma atractiva y organizada, facilitando que el visitante pase a ser cliente."
    },
    {
      icon: <FaSearch />,
      title: "SEO local para atraer clientes cercanos",
      description: "Optimizamos tu web para que aparezca cuando alguien busca tu tipo de negocio en tu zona. Esto trae clientes reales, no solo visitas."
    },
    {
      icon: <FaMobileAlt />,
      title: "Diseño responsive que funciona en todos los dispositivos",
      description: "Tu web se ve perfecta en móviles, tablets y ordenadores. El 68% de visitas vienen de móviles, no puedes permitirte fallar ahí."
    },
    {
      icon: <FaEuroSign />,
      title: "Precio final sin sorpresas",
      description: "Desde 200€ (pago único) y 20€/mes de mantenimiento. Sin costes ocultos ni sorpresas posteriores."
    },
    {
      icon: <FaChartLine />,
      title: "Datos reales sobre rendimiento",
      description: "Implementamos Google Analytics para que sepas exactamente cuántos clientes genera tu web y puedas medir el retorno de inversión."
    }
  ];
  
  // Planes de precios estandarizados
  const plans = [
    {
      title: 'Web Básica',
      price: 200,
      period: 'pago único',
      description: 'Para empresas que necesitan una web sencilla pero profesional para iniciar su presencia online.',
      features: [
        { text: 'Hasta 5 páginas (inicio, servicios, sobre ti, contacto, blog)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=basico',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Profesional',
      price: 300,
      period: 'pago único',
      description: 'La más solicitada por empresas. Equilibrio perfecto entre precio y funcionalidades para generar más ventas.',
      features: [
        { text: 'Hasta 10 páginas (más secciones y servicios)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: false },
        { text: 'Ficha de Google My Business', included: false },
        { text: 'Email Corporativo 1GB', included: false },
      ],
      isPopular: true,
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=estandar',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    },
    {
      title: 'Web Avanzada',
      price: 400,
      period: 'pago único',
      description: 'Para empresas que quieren destacar con más funcionalidades y mejor posicionamiento en su sector.',
      features: [
        { text: 'Hasta 15 páginas (contenido extenso y detallado)', included: true },
        { text: 'Adaptada a móviles y tablets', included: true },
        { text: 'Carga rápida con tecnología moderna', included: true },
        { text: 'Formulario de contacto funcional', included: true },
        { text: 'Botón de WhatsApp visible', included: true },
        { text: 'Enlaces a tus redes sociales', included: true },
        { text: 'Textos legales incluidos', included: true },
        { text: 'Análisis básico de palabras clave', included: true },
        { text: 'Sección de testimonios de clientes', included: true },
        { text: 'Dominio .es Gratis', included: true },
        { text: 'Ficha de Google My Business', included: true },
        { text: 'Email Corporativo 1GB', included: true },
      ],
      buttonText: 'Reservar consulta gratuita',
      buttonLink: '/reserva?plan=avanzado',
      maintenanceFee: '20€/mes incluye hosting, dominio y soporte',
    }
  ];
  
  // Proceso paso a paso simplificado
  const processSteps = [
    {
      number: 1,
      title: "Reunión para entender tu empresa",
      description: "Conversamos sobre tu negocio, productos y objetivos. Te explicamos todo el proceso sin tecnicismos para que entiendas cada fase del desarrollo.",
      icon: <FaComments />
    },
    {
      number: 2,
      title: "Diseño y desarrollo en tiempo récord",
      description: "Creamos tu web en 7-10 días con un diseño profesional que representa fielmente a tu empresa y está optimizado para conseguir clientes.",
      icon: <FaCode />
    },
    {
      number: 3,
      title: "Lanzamiento y primeros resultados",
      description: "Activamos tu web y te entregamos acceso completo. Te enseñamos a usarla y a medir resultados. Los primeros contactos suelen llegar en las primeras semanas.",
      icon: <FaRocket />
    }
  ];
  
  // Comparativa directa
  const comparisonItems = [
    {
      label: "Diseño adaptado a tu sector empresarial",
      us: true,
      others: false
    },
    {
      label: "Precio final sin costes ocultos",
      us: true,
      others: false
    },
    {
      label: "Enfoque en conversiones, no solo estética",
      us: true,
      others: false
    },
    {
      label: "Optimización SEO local incluida",
      us: true,
      others: false
    },
    {
      label: "Mantenimiento con precio fijo garantizado",
      us: true,
      others: false
    },
    {
      label: "Soporte técnico directo por WhatsApp",
      us: true,
      others: false
    }
  ];
  
  // Testimonio real para el sector
  const testimonial = {
    text: "Después de gastar miles de euros en publicidad tradicional con resultados mediocres, decidí probar una web profesional. La inversión fue mucho menor y los resultados muy superiores. En el primer mes recuperé la inversión con nuevos clientes y ahora la web es nuestro principal canal de ventas. El mantenimiento es económico y el soporte excelente.",
    author: "Miguel Sánchez",
    position: "Director General",
    company: "Suministros Industriales MCS",
    avatar: "/servicios/testimonios/empresario.webp"
  };
  
  // FAQs específicas para empresas
  const faqs = [
    {
      question: "¿Por qué mi empresa necesita una página web profesional?",
      answer: "Actualmente, el 87% de los consumidores investiga online antes de comprar, incluso para servicios locales. Sin presencia digital, tu empresa es invisible para estos clientes potenciales. Una web profesional te permite: captar clientes las 24 horas sin esfuerzo adicional, competir con empresas más grandes en igualdad de condiciones, transmitir una imagen profesional que genera confianza, reducir costes de publicidad tradicional, y expandir tu mercado más allá de tu zona física. A diferencia de redes sociales, tu web es una propiedad digital sobre la que tienes control total. Nuestros clientes reportan recuperar la inversión en cuestión de semanas con solo 1-2 ventas medianas generadas a través de la web.",
      category: "Estrategia"
    },
    {
      question: "¿Cuánto cuesta realmente tener una página web para mi empresa?",
      answer: "Nuestras webs para empresas tienen un coste único desde 350€ y un mantenimiento mensual de 20€ que incluye hosting, dominio, certificado de seguridad y soporte técnico. Este precio es final, sin sorpresas ni costes ocultos. La diferencia principal con opciones más caras (1.500€-3.000€) es que nosotros hemos optimizado procesos, automatizado tareas repetitivas y eliminado intermediarios, manteniendo la misma calidad final. Para empresas con necesidades más complejas como e-commerce, integraciones con otros sistemas o funcionalidades a medida, ofrecemos planes avanzados (desde 650€) que siguen siendo muy competitivos. Lo más importante: nuestro enfoque es lograr que recuperes la inversión rápidamente con nuevos clientes, no vender características innecesarias.",
      category: "Inversión"
    },
    {
      question: "¿En cuánto tiempo estará lista mi web corporativa?",
      answer: "El tiempo de desarrollo para una web corporativa estándar es de 7-10 días laborables desde la aprobación del diseño y la recepción de todo el material necesario (logotipo, fotos, información de productos). Este plazo incluye: diseño personalizado según tu identidad corporativa, implementación de la estructura, carga de contenidos, configuración técnica y pruebas de funcionamiento. Para webs más complejas (plan Premium) el plazo puede extenderse hasta 15 días. El proceso está optimizado para entregar la web lo antes posible sin comprometer la calidad ni las funcionalidades que tu empresa necesita. Una vez terminada, te damos acceso inmediato para que puedas empezar a promocionarla y obtener resultados.",
      category: "Plazos"
    },
    {
      question: "¿Cómo conseguirá mi web atraer clientes reales?",
      answer: "Nuestras webs para empresas están diseñadas específicamente para convertir visitantes en clientes, no solo para verse bonitas. Esto lo logramos mediante: optimización SEO local para aparecer cuando alguien busca tu tipo de negocio en tu zona, diseño centrado en la conversión con llamadas a la acción estratégicas, presentación clara de tus productos o servicios con énfasis en los beneficios para el cliente, elementos de credibilidad (testimonios, logos de clientes, certificaciones), formularios optimizados para maximizar los contactos, y velocidad de carga óptima que reduce abandonos. Además, te asesoramos sobre cómo promocionar tu web en Google My Business, redes sociales y otros canales relevantes para tu sector. El 78% de nuestros clientes empresariales reportan entre 5-20 nuevos contactos cualificados mensuales en los primeros tres meses.",
      category: "Resultados"
    },
    {
      question: "¿Podré actualizar yo mismo el contenido de la web?",
      answer: "Sí, todas nuestras webs corporativas incluyen un panel de control intuitivo que te permite actualizar textos, imágenes, productos y cualquier otro contenido sin conocimientos técnicos. No necesitarás instalar programas ni aprender código - todo se hace online a través de una interfaz similar a Word. Además, proporcionamos un video tutorial personalizado mostrando cómo realizar las actualizaciones más comunes en tu propia web. Para las empresas que prefieran no ocuparse de las actualizaciones, ofrecemos un servicio de gestión de contenidos por 50€/mes que incluye actualizaciones ilimitadas. La mayoría de nuestros clientes empresariales (65%) optan por gestionar ellos mismos el contenido básico y nos solicitan cambios solo para modificaciones más complejas.",
      category: "Gestión"
    },
    {
      question: "¿Qué sucede con el mantenimiento y la seguridad a largo plazo?",
      answer: "El mantenimiento mensual de 20€ incluye todo lo que tu web empresarial necesita para funcionar correctamente y de forma segura: alojamiento en servidores de alto rendimiento, renovación anual del dominio, certificado de seguridad SSL, copias de seguridad diarias, actualizaciones de seguridad, protección contra ataques maliciosos, y soporte técnico por email y WhatsApp. A diferencia de otros proveedores que cobran estos servicios por separado o incrementan precios tras el primer año, nosotros garantizamos que este coste permanecerá estable. El mantenimiento es esencial, ya que una web desactualizada o insegura puede dañar seriamente la reputación de tu empresa y perder posicionamiento en Google. Nuestro sistema de monitorización detecta y resuelve problemas antes de que afecten a tus clientes.",
      category: "Mantenimiento"
    }
  ];

  const founderMessage = "En el entorno empresarial actual, una web no es solo una tarjeta de presentación, sino una herramienta estratégica para generar oportunidades de negocio. Tras analizar cientos de webs corporativas, hemos desarrollado un enfoque que combina profesionalidad con capacidad de conversión, a un precio que cualquier empresa puede permitirse.";
  
  return (
    <HostingerStyleServiceTemplate
      // SEO optimizado para empresas
      pageTitle="Página Web para Empresas desde 200€ | Diseño Profesional que Genera Ventas"
      pageDescription="Diseñamos webs corporativas que atraen clientes y mejoran la imagen de tu empresa. Diseño profesional, catálogo de productos y optimización local incluidos."
      pageKeywords="página web barata empresas, diseño web corporativo, web para empresas, página web profesional empresa, diseño web barato empresa"
      canonicalUrl="https://webabajocoste.es/servicios/diseno-web-empresas"
      
      // Hero adaptado al buyer persona
      heroTitle="Web para empresas desde 200€ (que realmente genera clientes)"
      heroSubtitle="Diseño web profesional adaptado a tu sector empresarial. Presencia online que refleja la calidad de tu negocio y convierte visitas en ventas."
      heroImage="/servicios/tipo-cliente/hero-empresas.webp"
      badges={['Desde 200€ (pago único)', 'Entrega en 7-10 días', 'SEO local incluido', 'Mantenimiento 20€/mes']}
      heroCTAText="Solicitar presupuesto gratuito"
      heroCTALink="/reserva"
      
      // Secciones adaptadas
      pricingTitle="Planes para tu página web de empresa"
      pricingSubtitle="Elige el plan que mejor se adapte a las necesidades de tu negocio. Todos incluyen soporte técnico y mantenimiento por 20€/mes."
      plans={plans}
      
      featuresTitle="¿Por qué nuestras webs son ideales para empresas?"
      features={features}
      
      // Componente FounderInsight insertado como contenido personalizado
      customContent={
        <>
          <FounderInsight 
            insightText={founderMessage}
            founderName="Jaime Vela"
            founderTitle="Co-fundador y Director de Marketing"
            avatarSrc="/sobre nosotros/foto-jaime.webp"
          />
          
          <div style={{ 
            textAlign: 'center', 
            maxWidth: '800px', 
            margin: '3rem auto',
            padding: '2rem',
            background: '#f8f9fa',
            borderRadius: '10px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)'
          }}>
            <h3 style={{ marginBottom: '1rem', fontSize: '1.5rem' }}>¿Necesitas servicios adicionales?</h3>
            <p style={{ marginBottom: '1.5rem', color: 'var(--gray)' }}>
              Visita nuestra página de precios para conocer todas nuestras opciones de servicios sueltos, 
              paquetes personalizados y características adicionales para tu web.
            </p>
            <Button 
              as="a" 
              href="/precios" 
              variant="outline"
              size="medium"
            >
              Ver todos los precios
            </Button>
          </div>
        </>
      }
      
      processTitle="Creamos tu web corporativa: simple, rápido y orientado a resultados"
      processSteps={processSteps}
      
      comparisonTitle="¿Por qué las empresas nos eligen?"
      comparisonItems={comparisonItems}
      
      testimonial={testimonial}
      
      benefitsTitle="¿Qué conseguirás con una web profesional para tu empresa?"
      benefits={benefits}
      
      faqTitle="Preguntas frecuentes sobre webs para empresas"
      faqCategories={["Estrategia", "Inversión", "Plazos", "Resultados", "Gestión", "Mantenimiento"]}
      faqs={faqs}
      
      ctaTitle="Impulsa tu empresa con una presencia online profesional"
      ctaDescription="Empieza a captar clientes de forma automática. Tu web trabaja para ti mientras te centras en tu negocio."
      ctaButtonText="Solicitar presupuesto gratuito"
      ctaButtonLink="/reserva"
      
      relatedLinks={relatedLinks}
    />
  );
};

export default WebEmpresasPage; 

